// extracted by mini-css-extract-plugin
module.exports = {"full-size":"ComEvent-013a4543-scss"};